// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-2HYXiz_X clearfix","box_r":"box_r-1teFllyX","d_box":"d_box-2MVmafmj"};